var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vimeo-container"},[(_vm.path)?_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":_vm.iframeSrc,"frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture","title":"פתיח מתחילים - מירן"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }